import { BasePresenceSensor, type PresenceSignal } from "./base-presence";

export class DzPresenceSensor extends BasePresenceSensor {
  private isEnteredCode(code: string): boolean {
    if (code === 'AB') {
      return true;
    }
    if (!/^\d{2}$/.test(code)) {
      return false;
    }
    const value = Number.parseInt(code, 10);
    return value >= 1 && value <= 10;
  }

  protected parse(data: string): PresenceSignal | null {
    const dzMatch = data.match(/X001B\[Dz=([^\]]+)\]/i);
    if (!dzMatch || !dzMatch[1]) {
      return null;
    }

    const code = dzMatch[1].toUpperCase();
    if (code === 'XX') {
      return { state: 'left', code };
    }
    if (this.isEnteredCode(code)) {
      return { state: 'entered', code };
    }
    return null;
  }
}
